import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import EmbedHikePage from './EmbedHikePage';

/**
 * Embed page for full hike page iframe integration.
 *
 * URL params:
 * - hikeId: The ID of the hike to display
 *
 * Example: /embed/hike-page?hikeId=42
 */
export default function EmbedHikePageWrapper() {
  const [searchParams] = useSearchParams();

  const hikeId = searchParams.get('hikeId');

  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'auto';
    document.body.style.height = '100%';
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.height = '100%';

    const root = document.getElementById('root');
    if (root) {
      root.style.height = '100%';
    }

    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
      if (root) {
        root.style.height = '';
      }
    };
  }, []);

  if (!hikeId) {
    return (
      <div className="p-4 text-red-500 text-sm">
        Errore: hikeId mancante
      </div>
    );
  }

  return (
    <div
      className="bg-gray-50"
      style={{
        margin: 0,
        padding: '12px',
        boxSizing: 'border-box',
        overflow: 'auto',
        minHeight: '100%'
      }}
    >
      <div className="max-w-3xl mx-auto">
        <EmbedHikePage hikeId={parseInt(hikeId, 10)} />
      </div>
    </div>
  );
}
